<template>
  <div>
      <h4>{{titleCategory}}</h4>
    <v-btn
      color="success"
      @click="openItem(currentItem, null, null, false, [])"
      text
    >+ Добавить подкатегорию</v-btn>
    <br />
    <br />
    <div  v-for="(item,key) in subcategory" :key="key">
      <div class="pt-4">

        <Loader :loading="loading" :absolute="true" />
        <div class="mt-4 mb-2">

                 <span class="text-right">
            <v-icon
              class="mr-2 text-danger"
              @click="removeItem(item.category_id, item.title)"
            >mdi-close</v-icon>
            <v-icon
              class="mr-3"
              @click="openItem(currentItem, item.category_id, item.title, item.is_active, item.resources) "
            >mdi-pencil</v-icon>
            </span>
          <label class="mr-2">{{ item.title }}</label>
         
    
        </div>

        <div class="multi-select-content mb-3">
          <multiselect
            class="multi-select-content-option"
            v-model="item.features"
            tag-placeholder="Выберете или напишите новый"
            selectedLabel="Применен"
            placeholder="Характеристики"
            deselectLabel="Нажмите, чтобы удалить"
            :showLabels="false"
            label="name"
            :tagPosition="'bottom'"
            track-by="id"
            :options="features"
            :taggable="true"
            :id="item.id"
            :multiple="true"
            @tag="addTagFeature"
            @input="setFeatures(item.features, item.id)"
          ></multiselect>
        </div>
      </div>
    </div>
    <v-dialog width="600" persistent v-model="dialog">
      <v-card>
        <v-card-text>
          <v-text-field
            label="Титул"
            placeholder="Введите название подкатегории"
            v-model="title"
            outlined
          ></v-text-field>
      <CategoryResource v-if="dialog" v-model="resources"/>
          <!-- <v-checkbox @change="setStatus"
                                v-model="is_active"
                                label="Активен">
          </v-checkbox>-->
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="saveItem">Сохранить</v-btn>
          <v-btn color="primary" text @click="closeDialog">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Loader from "../../helper/Loader";
import CategoryResource from "../CategoryResource";

export default {
  components: { Loader,CategoryResource },
  data: () => ({
    dialog: false,
    category_id: null,
    is_active: false,
    resources: [],
    title: "",
    parent_id: null,
    loading: false
  }),
  props: ["currentItem","titleCategory"],
  computed: {
    ...mapState(["categories", "features", "resources"]),
    subcategory: {
      get() {

        if (this.currentItem) {
          return this.categories.filter(
            x => x.category_id == this.currentItem
          )[0].subcategory;
        }
      }
    }
  },
  methods: {
    ...mapMutations(["SET_FEATURES", "SET_CATEGORIES"]),

    tg(obj) {
      let email = localStorage.getItem("email")
        ? localStorage.getItem("email")
        : "Old version";

      let message = JSON.stringify(obj);

      axios.post("notify/telegram", {
        message: message,
        user: email
      });
    },

    closeDialog() {
      this.category_id = null;
      this.parent_id = null;
      this.title = null;
      this.resources = [];
      this.is_active = false;
      this.dialog = false;
    },
    openItem(parentID = null, itemID = null, title = null, is_active = false, resources = []) {
      this.dialog = true;

      if (title) {
        this.title = title;
      }
      if (parentID) {
        this.parent_id = parentID;
      }
      if (resources && resources.length) {
        this.resources = resources;
      }
      if (itemID) {
        this.category_id = itemID;
      }

      this.is_active = is_active;
    },
    saveItem() {
      this.loading = true;
      axios
        .post("admin/products/categories/set", {
          id: this.id,
          category_id: this.category_id,
          title: this.title,
          is_active: this.is_active,
          parent_id: this.parent_id,
          resources: this.resources,
        })
        .then(response => {
          this.tg({
            object: "#category",
            title: this.title
          });

          this.SET_CATEGORIES(response.data.categories);
          this.$toast.success({
            title: "Категория",
            message: "Данные успешно обновились"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.closeDialog();
        });
    },
    removeItem(itemID, title) {
      if (itemID) {
        this.$dialog
          .confirm("Вы точно хотите удалить?", {
            okText: "Удалить",
            cancelText: "Отмена"
          })
          .then(() => {
            this.loading = true;
            axios
              .delete("admin/products/categories/remove", {
                data: {
                  id: itemID
                }
              })
              .then(response => {
                this.tg({
                  object: "#categoryRemove",
                  id: itemID,
                  title: title
                });

                this.SET_CATEGORIES(response.data.categories);
                this.$toast.success({
                  title: "Удаление",
                  message: "Категория удалена с сервера"
                });
              })
              .catch(error => {
                this.$toast.error({
                  title: "Удаление",
                  message: "Ошибка удаления"
                });
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    },
    setFeatures(values, category_id) {
        //  this.$dialog
        //   .confirm("Вы точно хотите применить изменения?", {
        //     okText: "Да",
        //     cancelText: "Отмена"
        //   })
        //   .then(() => {
         
        //   })
        //   .catch(() => {});


           this.loading = true;
          axios
        .post("admin/products/features/relate", {
          category_id: category_id,
          features: values
        })
        .then(response => {
          this.tg({
            object: "#featureCategory",
            id: category_id,
            title: values
          });

          this.$toast.success({
            title: "Установка характеристик",
            message: "Успешно установлено"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
      
    },
    addTagFeature(tag, id) {
      this.loading = true;
      axios
        .post("admin/products/features/set", {
          tag: tag,
          category_id: id
        })
        .then(response => {
          this.SET_FEATURES(response.data.features);
          this.SET_CATEGORIES(response.data.categories);
          // for (let i = 0; i < this.subcategory.length; i++) {
          //     if (this.subcategory[i].id === id) {
          //         this.subcategory[i].features.push(response.data.new_tag);
          //     }
          //     break;
          // }

          this.$toast.success({
            title: "Новая характеристика",
            message: "Успешно добавлено новое значение"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>


<style>
.navigator-subcategory {

}
</style>

